import { useEffect, useState } from "react";
import { localUi } from "../i18n/uiFallback";

export function CounterTicker({ locale }: { locale: string }) {
  const [n, setN] = useState(1_287_340);
  useEffect(() => {
    const id = window.setInterval(
      () => setN((x) => x + Math.floor(1 + Math.random() * 4)),
      1200,
    );
    return () => window.clearInterval(id);
  }, []);
  return (
    <span>
      <span className="end__counter-n">{n.toLocaleString(locale)}</span>
      <span> · {localUi(locale, "decisions_today")}</span>
    </span>
  );
}
